export const TechChecklist = ({ technicians, value, onChange, testPrefix = "tech" }) => (
  <div className="mt-1.5 space-y-1.5 border rounded-sm p-2 max-h-44 overflow-y-auto bg-background">
    {technicians.length === 0 && <div className="text-xs text-muted-foreground p-1">Nenhum técnico cadastrado</div>}
    {technicians.map((t) => (
      <label key={t.id} className="flex items-center gap-2 text-sm cursor-pointer hover:bg-secondary p-1 rounded-sm">
        <input
          type="checkbox"
          checked={value.includes(t.id)}
          data-testid={`${testPrefix}-checkbox-${t.id}`}
          onChange={(e) => onChange(e.target.checked ? [...value, t.id] : value.filter((i) => i !== t.id))}
          className="w-4 h-4 rounded-sm accent-orange-500"
        />
        <span className="flex-1">{t.name}</span>
        <span className="text-xs text-muted-foreground">{t.email}</span>
      </label>
    ))}
  </div>
);
